
import { MasterLayout } from 'layout';
import React from 'react';
import { Link } from 'react-router';
import { Button, Dialog } from "@blueprintjs/core";
import { DataTableDoiTuongThanhTra, RowItemDoiTuongThanhTra } from './datatable/list';
import { connect } from 'react-redux';
import { Danhmuc, DuLieuHeThong, ThanhTra, Reception, TrangChu } from 'api';
import { header } from 'constants/table';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { CheckPermission } from 'modules/login/CheckPermission';
import { TextArea, Input, DropDown } from 'components/tt-forms/common';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import { isEmpty, get, head } from 'lodash';
import { ShowIf } from 'components/utils';

class DoiTuongThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      ma: '',
      loaiDoiTuongTT: 'CA_NHAN',
      loaiDoiTuongTTList: [],
      linhVucDoiTuongTT: '',
      linhVucDoiTuongTTList: [],
      nhomDoiTuongThanhTraId: 2,
      doiTuongTT: '',
      diaChi: '',
      soDienThoai: '',
      ghiChu: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa: '',
      search: false,
      loaiDoiTuongFilter: '',
      linhVucDoiTuongFilter: '',
      timKiemNangCao: false,
      dsQuanHuyen: [],
      dsPhuongXa: [],
      quanHuyenId: '',
      phuongXaId: '',
      showDialogDuLieuLoi: false,
      paramsRequestDuLieuLoi: null,
      doiTuongSelecteds: [],
      thanhTraThanhPhoId: '',
      isTTTP: false
    };
  }

  componentDidMount() {
    this.getLinhVucDoiTuongTTList();
    this.getLoaiDoiTuongThanhTraList();
    this.getNhomDoiTuongThanhTra();
    this.getListData();
    this.getQuanHuyen();
    this.checkDonVi();
  }

  checkDonVi() {
    TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(res => {
      const { data } = res;
      this.setState({
        ...this.state,
        isTTTP: data,
      });
    })
  }

  getNhomDoiTuongThanhTra() {
    const params = {
      page: 0,
      size: 1000,
      sort: 'ngaySua,asc'
    };
    Danhmuc.actions.getNhomDoiTuongThanhTra.request(null, params).then(res => {
      if (!isEmpty(res.data._embedded.nhomDoiTuongThanhTras)) {
        this.setState({
          listNhomDoiTuong: res.data._embedded.nhomDoiTuongThanhTras
        });
      } else {
        this.setState({
          listNhomDoiTuong: []
        });
      }
    });
  }

  getQuanHuyen() {
    DuLieuHeThong.actions.getQuanHuyen.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dsQuanHuyen: get(res, 'data._embedded.donViHanhChinhs')
        })
      }
    })
  }

  getPhuongXa(quanHuyenId = undefined) {
    if (quanHuyenId) {
      DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(res => {
        this.setState({
          dsPhuongXa: get(res, 'data._embedded.donViHanhChinhs') || []
        })
      })
    }
  }

  getCheckTrungMaDoanhNghiep(id, code) {
    ThanhTra.actions.getCheckTrungMaDoanhNghiep.request({ id: id || undefined, code: code.trim() }).then(res => {
      this.setState({
        ...this.state,
        isTrungMa: res.data
      })
    })
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    if (name === 'quanHuyenId') {
      this.getPhuongXa(e.target.value);
      if (!e.target.value) {
        this.setState({
          phuongXaId: '',
          dsPhuongXa: [],
        })
      } else {
        this.setState({
          phuongXaId: ''
        })
      }
    }
    if (name === 'ma') {
      this.setState({
        isTrungMa: false
      })
    }
  }

  onChangeInput(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleSearch(e) {
    e.preventDefault();
    this.state.search = true;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({ ...this.state });
    this.getListData(true);
  }

  getLinhVucDoiTuongTTList() {
    let params = {
      page: 0,
      size: 1000,
      sort: 'ngaySua,asc'
    }
    Danhmuc.actions.getLinhVucDoiTuongThanhTra.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.state.linhVucDoiTuongTTList = res.data._embedded.linhVucDoiTuongThanhTras;
      } else {
        this.state.linhVucDoiTuongTTList = [];
      }
      this.setState({ ...this.state });
    });
  }

  getLoaiDoiTuongThanhTraList() {
    let params = {
      page: 0,
      size: 1000,
      sort: 'ngaySua,asc'
    }
    Danhmuc.actions.getLoaiDoiTuongThanhTra.request(null, params).then(res => {
      if (res.data) {
        this.state.loaiDoiTuongTTList = res.data;
        this.state.loaiDoiTuongTT = res.data[0].giaTri;
      } else {
        this.state.loaiDoiTuongTTList = [];
      }
      this.setState({ ...this.state });
    });
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    if (this.state.maSoThue) {
      params.maSoThue = this.state.maSoThue.trim();
    }
    if (this.state.timKiemNangCao) {
      if (this.state.loaiDoiTuongFilter) {
        params.loaiDoiTuongThanhTra = this.state.loaiDoiTuongFilter;
      }
      if (this.state.linhVucDoiTuongFilter) {
        params.linhVucId = this.state.linhVucDoiTuongFilter;
      }
    }
    Danhmuc.actions.getDoiTuongThanhTra.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.doiTuongThanhTras,
          pageData: res.data.page,
          tableLoading: false,
          // doiTuongSelecteds: res.data._embedded.doiTuongThanhTras.filter(item => item.approved).map(item => item.doiTuongThanhTraId)
        });
      } else {
        if (this.state.pageData.number > 0) {
          this.state.pageData.number -= 1;
          this.getListData();
        }
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  async checkValidate() {
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    if (this.state.ma) {
      await this.getCheckTrungMaDoanhNghiep(this.state.doiTuongTT, this.state.ma);
      if (this.state.isTrungMa) {
        pass = false;
      }
    }
    return pass;
  }

  createCategory() {
    this.checkValidate().then(data => {
      if (data) {
        let params = {
          ten: this.state.ten.trim(),
          loaiDoiTuongThanhTra: this.state.loaiDoiTuongTT,
        };
        if (this.state.ma) {
          params.ma = this.state.ma.trim();
        }
        if (this.state.linhVucDoiTuongTT) {
          params.linhVucDoiTuongThanhTra = { id: this.state.linhVucDoiTuongTT };
        }
        if (this.state.diaChi) {
          params.diaChi = this.state.diaChi.trim();
        }
        if (this.state.ghiChu) {
          params.ghiChu = this.state.ghiChu.trim();
        }
        if (this.state.soDienThoai) {
          params.soDienThoai = this.state.soDienThoai.trim();
        }
        if (this.state.nhomDoiTuongThanhTraId) {
          params.nhomDoiTuongThanhTra = { id: this.state.nhomDoiTuongThanhTraId };
        }
        if (this.state.quanHuyenId) {
          params.quanHuyen = { id: Number(this.state.quanHuyenId) };
        }
        if (this.state.phuongXaId) {
          params.phuongXa = { id: Number(this.state.phuongXaId) };
        }
        params.approved = this.state.approved
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          Danhmuc.actions.updateDoiTuongThanhTra.request({ id: this.state.doiTuongTT }, params).then(res => {
            this.getListData();
            this.toggleDialog();
            Toastr(msg.updateCategorySucess, 'success');
            this.setState({ buttonLoading: false });
          }).catch(error => {
            if (error.response) {
              this.setState({ buttonLoading: false });
            }
          });
        } else {
          Danhmuc.actions.postDoiTuongThanhTra.request('', params).then(res => {
            this.getListData();
            this.toggleDialog();
            Toastr(msg.addCategorySucess, 'success');
            this.setState({ buttonLoading: false });
          }).catch(error => {
            if (error.response) {
              this.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    })
  }

  onApprove() {
    this.checkValidate().then(data => {
      if (data) {
        let params = {
          ten: this.state.ten.trim(),
          loaiDoiTuongThanhTra: this.state.loaiDoiTuongTT,
        };
        if (this.state.ma) {
          params.ma = this.state.ma.trim();
        }
        if (this.state.linhVucDoiTuongTT) {
          params.linhVucDoiTuongThanhTra = { id: this.state.linhVucDoiTuongTT };
        }
        if (this.state.diaChi) {
          params.diaChi = this.state.diaChi.trim();
        }
        if (this.state.ghiChu) {
          params.ghiChu = this.state.ghiChu.trim();
        }
        if (this.state.soDienThoai) {
          params.soDienThoai = this.state.soDienThoai.trim();
        }
        if (this.state.nhomDoiTuongThanhTraId) {
          params.nhomDoiTuongThanhTra = { id: this.state.nhomDoiTuongThanhTraId };
        }
        if (this.state.quanHuyenId) {
          params.quanHuyen = { id: Number(this.state.quanHuyenId) };
        }
        if (this.state.phuongXaId) {
          params.phuongXa = { id: Number(this.state.phuongXaId) };
        }
        params.approved = true;
        this.setState({ buttonLoading: true });
        if (this.state.addType == 2) {
          Danhmuc.actions.updateDoiTuongThanhTra.request({ id: this.state.doiTuongTT }, params).then(res => {
            this.getListData();
            this.toggleDialog();
            Toastr('Duyệt đối tượng thanh tra thành công', 'success');
            this.setState({ buttonLoading: false });
          }).catch(error => {
            if (error.response) {
              this.setState({ buttonLoading: false });
            }
          });
        } else {
          Danhmuc.actions.postDoiTuongThanhTra.request('', params).then(res => {
            this.getListData();
            this.toggleDialog();
            Toastr('Duyệt đối tượng thanh tra thành công', 'success');
            this.setState({ buttonLoading: false });
          }).catch(error => {
            if (error.response) {
              this.setState({ buttonLoading: false });
            }
          });
        }
        this.props.validators['danhMuc'] = [];
      }
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.setState({
      ...this.state,
      doiTuongSelecteds: [],
    })
    this.getListData();
  }

  handleDelete(categoryId) {
    if (categoryId) {
      this.setState({ buttonLoading: true });
      Danhmuc.actions.deleteDoiTuongThanhTra.request({ id: categoryId }).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess, 'success');
        this.setState({ buttonLoading: false });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
          this.setState({ buttonLoading: false });
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  toggleDialog() {
    this.setState({ popupAddCategory: !this.state.popupAddCategory });
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      isTrungMa: false,
      addType: 0,
      ma: '',
      ten: '',
      doiTuongTT: '',
      soDienThoai: '',
      diaChi: '',
      ghiChu: '',
      linhVucDoiTuongTT: '',
      nhomDoiTuongThanhTraId: 2,
      loaiDoiTuongTT: this.state.loaiDoiTuongTTList.length ? this.state.loaiDoiTuongTTList[0].giaTri : '',
      quanHuyenId: '',
      phuongXaId: '',
    });
  }

  openUpdateCategory(item) {
    this.setState({
      isTrungMa: false,
      approved: get(item, 'approved'),
      popupAddCategory: true,
      addType: 2,
      doiTuongTT: get(item, 'doiTuongThanhTraId'),
      ma: get(item, 'ma'),
      ten: get(item, 'ten'),
      diaChi: get(item, 'diaChi'),
      soDienThoai: get(item, 'soDienThoai'),
      ghiChu: get(item, 'ghiChu'),
      loaiDoiTuongTT: get(item, 'loaiDoiTuongThanhTra'),
      nhomDoiTuongThanhTraId: get(item, 'nhomDoiTuongThanhTraInfo.nhomDoiTuongThanhTraId'),
      quanHuyenId: get(item, 'quanHuyenInfo.id'),
      phuongXaId: get(item, 'phuongXaInfo.id'),
    })
  }

  toggleSearch(status) {
    if (status) {
      this.state.timKiemNangCao = true;
    } else {
      this.state.timKiemNangCao = false;
    }
    this.setState({ ...this.state });
  }

  onBlurMa(e) {
    if (this.state.ma) {
      this.getCheckTrungMaDoanhNghiep(this.state.doiTuongTT, this.state.ma);
    }
  }

  handleImportDoiTuongThanhTra(e) {
    let params = {
      field: 'file',
      file: e.target.files[0]
    };
    Reception.actions.postImportDoiTuongThanhTra.request('', params).then(res => {
      const data = res.data;
      if (data === '') {
        Toastr('Import thành công', 'success');
        this.getListData();
      } else {
        this.getListData();
        this.toggleDialogDuLieuLoi(params)
      }
    }).catch(error => {
      Toastr(get(error, 'response.data.errors[0].detail'), 'error');
    });
  }

  toggleDialogDuLieuLoi(params) {
    this.setState({
      ...this.state,
      showDialogDuLieuLoi: !this.state.showDialogDuLieuLoi,
      paramsRequestDuLieuLoi: params
    })
  }

  handleDownloadDuLieuLoi() {
    Reception.actions.postDownloadDsLoiDoiTuongThanhTra.request('', this.state.paramsRequestDuLieuLoi).then(res => {
      if (res.data) {
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(res.data);
        a.href = url;
        a.download = 'filedulieuloi.xlsx';
        a.click();
      }
    }).catch(error => {
      Toastr(get(error, 'response.data.errors[0].detail'), 'error');
    });
  }

  onCheckAll(e) {
    if (e.target.checked) {
      this.setState({
        ...this.state,
        doiTuongSelecteds: this.state.data.filter(i => !i.approved).map(item => item.doiTuongThanhTraId)
      })
    } else {
      this.setState({
        ...this.state,
        doiTuongSelecteds: []
      })
    }
  }

  handleSelectedDoiTuong(e, item) {
    const checked = e.target.checked;
    const id = item.doiTuongThanhTraId;
    const result = this.state.doiTuongSelecteds;
    if (checked) {
      this.setState({
        ...this.state,
        doiTuongSelecteds: [...result, id]
      })
    } else {
      this.setState({
        ...this.state,
        doiTuongSelecteds: this.state.doiTuongSelecteds.filter(item => item !== id)
      })
    }
  }

  // handleApprove() {
  //   this.checkValidate().then((data) => {
  //     if(data) {
  //       ThanhTra.actions.approveDoiTuongThanhTra.request('', { ids: [this.state.doiTuongTT] }).then(res => {
  //         this.getListData()
  //         Toastr('Duyệt đối tượng thanh tra thành công', 'success');
  //         this.toggleDialog()
  //       }).catch(error => {
  //         if (error.response) {
  //           Toastr(error.response.data.errors[0].detail, 'error');
  //         }
  //       });
  //       this.props.validators['danhMuc'] = [];
  //     }
  //   })
  //   }

  render() {
    const idNhomCoQuanHanhChinh = get(head(get(this.state, 'listNhomDoiTuong', []).filter(item => item.ten === 'Cơ quan hành chính')), 'nhomDoiTuongThanhTraId')
    const isDisabledCheckAll = this.state.data.every(item => item.approved);
    const totalApproved = this.state.data.filter(item => item.approved).length;
    const isCheckedAll = (this.state.data.length > 0) && (this.state.doiTuongSelecteds.length > 0) && (totalApproved + this.state.doiTuongSelecteds.length === this.state.data.length)
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Đối tượng thanh tra</p>
            </div>
            <div className="right-content d-flex">
              <div className="upload_file_content width-auto">
                <input type="file" accept='.xls, .xlsx' name="uploadFile" className="upload btn-green" ref='btnUpload' onChange={this.handleImportDoiTuongThanhTra.bind(this)} />
                <Link htmlFor="file" className="btn-blue" onClick={this.handleImportDoiTuongThanhTra.bind(this)}><i className="tt tt-upload-big-arrow-white mr5"></i>Import đối tượng thanh tra</Link>
              </div>
              {
                CheckPermission('DOITUONGTHANHTRA_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                  : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className={this.state.timKiemNangCao ? 'search-container super-search' : 'search-container'}>
              <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
                {
                  this.state.timKiemNangCao ? <Input  label="Từ khóa" value={this.state.tuKhoa} onChange={this.onChangeInput.bind(this, 'tuKhoa')} placeholder="Nhập từ khóa để tìm kiếm..." /> :
                  <InputTuKhoa value={this.state.tuKhoa} onChange={this.onChange.bind(this, 'tuKhoa')} placeholderText="Nhập từ khóa để tìm kiếm..." />
                }
                <Input label="Mã số thuế" value={this.state.maSoThue} onChange={this.onChangeInput.bind(this, 'maSoThue')} placeholder="Nhập mã số thuế..." />
                <DropDown label="Loại đối tượng thanh tra" selectedValue={this.state.loaiDoiTuongFilter} onChange={this.onChange.bind(this, 'loaiDoiTuongFilter')} options={this.state.loaiDoiTuongTTList} keyName="giaTri" valueName="ten" placeholder />
                <div className="btn-wrap">
                  <Button className={`btn-green tt-search`} text="Tìm kiếm" type="submit" disabled={this.state.searching ? 'disabled' : ''} />
                </div>
                {
                  this.state.timKiemNangCao ?
                    <div className='clear-left'>
                      <div className="input-group" style={{ float: 'right' }}>
                        <Link className={this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search"} onClick={this.toggleSearch.bind(this, false)}><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
                      </div>
                    </div>
                    : ''
                }
              </form>
              <Link className="rearch-text" onClick={this.toggleSearch.bind(this, true)}><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <DataTableDoiTuongThanhTra
              header={header.doiTuongThanhTra}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent={this}
              tableLoading={this.state.tableLoading}
              showCheckbox={true}
              selectAllStatus={isCheckedAll}
              isDisabledCheckAll={isDisabledCheckAll}
              onCheck={this.onCheckAll.bind(this)}
              doiTuongSelecteds={this.state.doiTuongSelecteds}
              isTTTP={this.state.isTTTP}
              getListData={this.getListData.bind(this)}
            >
              <RowItemDoiTuongThanhTra
                parent={this}
                doiTuongSelecteds={this.state.doiTuongSelecteds}
                isTTTP={this.state.isTTTP}
              />
            </DataTableDoiTuongThanhTra>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa đối tượng thanh tra' : 'Thêm mới đối tượng thanh tra'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body row">
              <Input
                trungMa={this.state.isTrungMa}
                className="col-12"
                label="Mã số doanh nghiệp"
                onBlur={this.onBlurMa.bind(this)}
                value={this.state.ma}
                require={Number(this.state.nhomDoiTuongThanhTraId) !== idNhomCoQuanHanhChinh}
                maxLength={255}
                onChange={this.onChange.bind(this, 'ma')}
                bindValidator={this}
                channel="danhMuc"
              />
              <Input className="col-12" label="Tên" value={this.state.ten} require={true} maxLength={255} onChange={this.onChange.bind(this, 'ten')} bindValidator={this} channel="danhMuc" />
              <DropDown className="col-12" label="Nhóm đối tượng thanh tra" selectedValue={this.state.nhomDoiTuongThanhTraId} placeholder={null} onChange={this.onChange.bind(this, 'nhomDoiTuongThanhTraId')} options={this.state.listNhomDoiTuong} valueName="ten" keyName="nhomDoiTuongThanhTraId" />
              <DropDown className="col-12" label="Loại đối tượng thanh tra" selectedValue={this.state.loaiDoiTuongTT} placeholder={null} onChange={this.onChange.bind(this, 'loaiDoiTuongTT')} options={this.state.loaiDoiTuongTTList} valueName="ten" keyName="giaTri" />
              <Input className="col-12" label="Địa chỉ" value={this.state.diaChi} maxLength={255} onChange={this.onChange.bind(this, 'diaChi')} />
              <DropDown
                className='col-12'
                label="Huyện/TP"
                selectedValue={this.state.quanHuyenId}
                onChange={this.onChange.bind(this, 'quanHuyenId')}
                name='quanHuyenId'
                placeholder
                options={this.state.dsQuanHuyen} keyName="donViHanhChinhId" valueName="ten"
              />
              <DropDown
                className='col-12'
                label="Phường/Xã"
                selectedValue={this.state.phuongXaId}
                onChange={this.onChange.bind(this, 'phuongXaId')}
                name='phuongXaId'
                placeholder
                options={this.state.dsPhuongXa} keyName="donViHanhChinhId" valueName="ten"
              />
              <Input className="col-12" label="Số điện thoại" value={this.state.soDienThoai} maxLength={40} onChange={this.onChange.bind(this, 'soDienThoai')} />
              <TextArea label="Ghi chú" maxLength={1000} rows={5} value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} className='col-12' />
            </div>
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
              <ShowIf condition={this.state.addType == 2 && this.state.isTTTP && !this.state.approved}>
                <Button style={{ width: '100px' }} className="btn-blue tt-approve-double-check" text='Duyệt' onClick={this.onApprove.bind(this)} />
              </ShowIf>
            </div>
          </Dialog>
          <Dialog
            isOpen={this.state.showDialogDuLieuLoi}
            onClose={this.toggleDialogDuLieuLoi.bind(this)}
            title="Thông báo"
            className="panel-popup category medium"
            style={{ width: 350 }}
          >
            <div className="pt-dialog-body">
              Danh sách đối tượng thanh tra vừa tải lên có đối tượng bị lỗi. Vui lòng bấm tải xuống danh sách lỗi để kiểm tra lại
            </div>
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialogDuLieuLoi.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={"btn-action btn-save"} onClick={this.handleDownloadDuLieuLoi.bind(this)}>
                <span>Tải xuống danh sách lỗi</span>
              </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}
DoiTuongThanhTra.defaultProps = {
  validators: {}
}
function bindStateToProps(state) {
  return {};
}
export default connect(bindStateToProps)(DoiTuongThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/category/DoiTuongThanhTra.jsx